import { useContext, useCallback, useMemo } from 'react';
import get from 'lodash/get';

import { getLocalizedNodes } from '@helpers';
import i18nContext from '@components/i18n/i18nContext';

export function useHeaderFooter() {
  const { lng } = useContext(i18nContext);
  const allData = {
    allMenuLinkContentMenuLinkContent: {
      group: [
        {
          field: 'menu_name',
          fieldValue: 'footer-second-en',
          nodes: [
            {
              langcode: 'en',
              drupal_id: '9ce3cc05-2df2-4771-b21b-2124be9c4ba5',
              link: {
                uri_alias: 'internal:?modal=ContactSales',
                uri_uuid: '',
              },
              external: false,
              title: 'Contact Lucid Sales',
              weight: -49,
            },
            {
              langcode: 'en',
              drupal_id: '4e7b9e68-bcb6-4458-bf89-7b2d0563726d',
              link: {
                uri_alias: 'internal:?modal=CorporateInquiry',
                uri_uuid: '',
              },
              external: false,
              title: 'Corporate Inquiry',
              weight: -48,
            },
          ],
        },
        {
          field: 'menu_name',
          fieldValue: 'footer-third-en',
          nodes: [
            {
              langcode: 'en',
              drupal_id: '5e35283f-2510-48bd-a00d-de09f99124d9',
              link: {
                uri_alias: '/mediaroom/',
                uri_uuid: '',
              },
              external: false,
              title: 'Mediaroom',
              weight: -50,
            },
            {
              langcode: 'en',
              drupal_id: '0b891584-f0f4-470b-b323-6ffb95e1d482',
              link: {
                uri_alias: '/login/',
                uri_uuid: '',
              },
              external: false,
              title: 'Login',
              weight: -49,
            },
          ],
        },
        {
          field: 'menu_name',
          fieldValue: 'main',
          nodes: [
            {
              langcode: 'en',
              drupal_id: 'dd675ab3-1244-4b35-a1e6-2e0242945c79',
              link: {
                uri_alias: '/stories',
                uri_uuid:
                  'entity:node/landing_page/bbfcec45-099d-4273-80e0-fc1f55f9ea3a',
              },
              external: false,
              title: 'Stories',
              weight: -47,
            },
            {
              langcode: 'ar',
              drupal_id: 'dd675ab3-1244-4b35-a1e6-2e0242945c79',
              link: {
                uri_alias: '/ar/stories',
                uri_uuid:
                  'entity:node/landing_page/bbfcec45-099d-4273-80e0-fc1f55f9ea3a',
              },
              external: false,
              title: 'Stories',
              weight: -47,
            },
            {
              langcode: 'en-ca',
              drupal_id: 'dd675ab3-1244-4b35-a1e6-2e0242945c79',
              link: {
                uri_alias: '/en-ca/stories',
                uri_uuid:
                  'entity:node/landing_page/bbfcec45-099d-4273-80e0-fc1f55f9ea3a',
              },
              external: false,
              title: 'Stories',
              weight: -47,
            },
          ],
        },
      ],
    },
    allBlockContentHtmlBlock: {
      nodes: [
        {
          langcode: 'en',
          drupal_id: 'c0d4544a-632b-435e-9495-11d36f2fe360',
          drupal_internal__id: 1,
          info: 'Copyrights',
          internal: {
            type: 'block_content__html_block',
          },
          body: {
            processed: '<p>© 2022 Lucid. All rights reserved</p>\n',
          },
        },
        {
          langcode: 'en',
          drupal_id: '912192a6-27e8-4ddf-b9d2-701d7e979bc4',
          drupal_internal__id: 2,
          info: 'Privacy Policy / Terms of Services',
          internal: {
            type: 'block_content__html_block',
          },
          body: {
            processed:
              '<p><a href="/privacy-policy/">Privacy Policy</a> / <a href="/terms-use/">Terms of Services</a></p>\n',
          },
        },
        {
          langcode: 'en',
          drupal_id: 'ba6a694a-5575-4977-b930-3269ece2a624',
          drupal_internal__id: 5,
          info: 'Cookie Popup',
          internal: {
            type: 'block_content__html_block',
          },
          body: {
            processed:
              '<p>This site uses cookies as described in our <a href="/legal#privacy-policy">Privacy Policy</a> and <a href="/legal#cookie-policy">Cookie Policy</a>. By acknowledging this message or continuing to browse our site, you agree to accept cookies and accept our <a href="/legal#terms-of-use">Terms of Use</a>. </p>\n',
          },
        },
        {
          langcode: 'ar',
          drupal_id: 'ba6a694a-5575-4977-b930-3269ece2a624',
          drupal_internal__id: 5,
          info: 'Cookie Popup',
          internal: {
            type: 'block_content__html_block',
          },
          body: {
            processed:
              '<p>هذا الموقع يستعمل ملفات تعريف الارتباط كما وصفت في <a href="/ar/legal#privacy-policy">سياسة الخصوصية</a> الخاصة بنا . بقرارك بهذي الرسالة او بأستمرارك في تصفح موقعنا، فأنت توافق على استخدامنا لملفات تعريف الارتباط وتوافق على <a href="/ar/legal#terms-of-use">شروط الاستخدام</a> الخاصة بنا .</p>\n',
          },
        },
        {
          langcode: 'en-ca',
          drupal_id: 'ba6a694a-5575-4977-b930-3269ece2a624',
          drupal_internal__id: 5,
          info: 'Cookie Popup',
          internal: {
            type: 'block_content__html_block',
          },
          body: {
            processed:
              '<p>This site uses cookies as described in our <a href="/en-ca/legal#privacy-policy">Privacy Policy</a>. By acknowledging this message or continuing to browse our site, you agree to accept cookies and accept our <a href="/en-ca/legal#terms-of-use">Terms of Use</a>. </p>\n',
          },
        },
      ],
    },
    allBlockContentBanner: {
      nodes: [
        {
          langcode: 'en',
          drupal_id: 'b51560cd-9de4-4f32-ab5b-e9f18ae033f2',
          field_links: [
            {
              title: '',
              uri_alias: '',
              uri_uuid: '',
            },
            {
              title: 'Reserve now',
              uri_alias: '/reserve/',
              uri_uuid: '',
            },
          ],
          field_title: 'AIR',
          relationships: {
            field_background_image: {
              relationships: {
                field_media_image: {
                  localFile: {
                    publicURL:
                      '/static/0a69982370e3884e9cb9632c4ad62037/lucid-air-city-skyline-1920x1448.jpg',
                    childImageSharp: {
                      gatsbyImageData: {
                        layout: 'fullWidth',
                        placeholder: {
                          fallback:
                            'data:image/jpeg;base64,/9j/2wBDAAIBAQEBAQIBAQECAgICAgQDAgICAgUEBAMEBgUGBgYFBgYGBwkIBgcJBwYGCAsICQoKCgoKBggLDAsKDAkKCgr/2wBDAQICAgICAgUDAwUKBwYHCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgr/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAgJAgT/xAAVAQEBAAAAAAAAAAAAAAAAAAAEA//aAAwDAQACEAMQAAABZLc+uaaaJCKhlf/EABoQAAIDAQEAAAAAAAAAAAAAAAQFAQIGAwf/2gAIAQEAAQUCgwQat9QHyjrtB6WYbV+3IbaTSs7r/TNOvB//xAAbEQACAQUAAAAAAAAAAAAAAAAAAQIDBBNSYf/aAAgBAwEBPwGNRqXDPbaH/8QAGBEBAQADAAAAAAAAAAAAAAAAAgATUWH/2gAIAQIBAT8BRCPbEt3/xAAjEAACAQQBAwUAAAAAAAAAAAABAgMABBESExQhIiQxYaGi/9oACAEBAAY/Ai0lwqge+TQht7+Pl8Tx7jOprXj/AFXUm/mDa4wlwyD6qAmRPSgrE0zsxI+aistLV+JNdnXua//EABwQAQACAwADAAAAAAAAAAAAAAEAESExcVFh4f/aAAgBAQABPyHYmFpiQLM48iuTY5N38ywiWEXCoRj8WNrgzrHL9w4lANejU//aAAwDAQACAAMAAAAQI/8A/8QAGBEBAAMBAAAAAAAAAAAAAAAAAQAR0WH/2gAIAQMBAT8QJ2D1ADTs/8QAGBEAAgMAAAAAAAAAAAAAAAAAABEB0fD/2gAIAQIBAT8QnTY2VH//xAAcEAEBAQEAAgMAAAAAAAAAAAABESEAMVFBcYH/2gAIAQEAAT8QHNlLP36++MNY8LU2aKtOVpYIMa+uZjLNdDeCBSIuzqquIbTNZylHVZCuAO4VqU+fle//2Q==',
                        },
                        images: {
                          fallback: {
                            src: '/static/0a69982370e3884e9cb9632c4ad62037/262ab/lucid-air-city-skyline-1920x1448.jpg',
                            srcSet:
                              '/static/0a69982370e3884e9cb9632c4ad62037/012b3/lucid-air-city-skyline-1920x1448.jpg 750w,\n/static/0a69982370e3884e9cb9632c4ad62037/71dc4/lucid-air-city-skyline-1920x1448.jpg 1080w,\n/static/0a69982370e3884e9cb9632c4ad62037/9d60f/lucid-air-city-skyline-1920x1448.jpg 1366w,\n/static/0a69982370e3884e9cb9632c4ad62037/262ab/lucid-air-city-skyline-1920x1448.jpg 1920w',
                            sizes: '100vw',
                          },
                          sources: [
                            {
                              srcSet:
                                '/static/0a69982370e3884e9cb9632c4ad62037/74839/lucid-air-city-skyline-1920x1448.webp 750w,\n/static/0a69982370e3884e9cb9632c4ad62037/cba3c/lucid-air-city-skyline-1920x1448.webp 1080w,\n/static/0a69982370e3884e9cb9632c4ad62037/4dc0d/lucid-air-city-skyline-1920x1448.webp 1366w,\n/static/0a69982370e3884e9cb9632c4ad62037/f53d7/lucid-air-city-skyline-1920x1448.webp 1920w',
                              type: 'image/webp',
                              sizes: '100vw',
                            },
                          ],
                        },
                        width: 1,
                        height: 0.7541666666666667,
                      },
                    },
                  },
                },
              },
            },
          },
          drupal_internal__id: 4,
          id: '9b9d9e05-3a90-5cf3-87fd-4539dbda476c',
          info: 'Luxury EV',
          internal: {
            type: 'block_content__banner',
          },
        },
      ],
    },
    allBlockContentSocialLinksBlock: {
      nodes: [
        {
          langcode: 'en',
          relationships: {
            field_social_link: [
              {
                field_social_media_type: 'facebook',
                field_social_media_link: {
                  uri: 'https://www.facebook.com/LucidMotors/',
                },
              },
              {
                field_social_media_type: 'instagram',
                field_social_media_link: {
                  uri: 'https://www.instagram.com/lucidmotors/',
                },
              },
              {
                field_social_media_type: 'twitter',
                field_social_media_link: {
                  uri: 'https://twitter.com/LucidMotors',
                },
              },
              {
                field_social_media_type: 'youtube',
                field_social_media_link: {
                  uri: 'https://www.youtube.com/lucidmotors',
                },
              },
            ],
          },
        },
      ],
    },
    allNodeLandingPage: {
      nodes: [],
    },
  };
  // Filter data by language.
  const data = useMemo(() => {
    const filteredData = {};
    Object.keys(allData).forEach(nodesGroup => {
      const nodesGroupData = allData[nodesGroup];
      if (nodesGroupData.group) {
        filteredData[nodesGroup] = {
          ...nodesGroupData,
          group: nodesGroupData.group.map(group => ({
            ...group,
            nodes: getLocalizedNodes(group.nodes, lng),
          })),
        };
      }
      if (nodesGroupData.nodes) {
        filteredData[nodesGroup] = {
          ...nodesGroupData,
          nodes: getLocalizedNodes(nodesGroupData.nodes, lng),
        };
      }
    });

    return filteredData;
  }, [allData, lng]);

  const getBlock = useCallback(
    blockID => {
      let block = data.allBlockContentHtmlBlock.nodes.find(
        item => item.drupal_id === blockID
      );
      if (!block) {
        block = {
          body: {
            processed: '',
          },
        };
      }
      return block;
    },
    [data]
  );

  const getMenuLinks = useCallback(
    menuName => {
      const menu = data.allMenuLinkContentMenuLinkContent.group.find(
        group => group.fieldValue === menuName
      );
      if (menu && menu.nodes) {
        return data.allMenuLinkContentMenuLinkContent.group
          .find(group => group.fieldValue === menuName)
          .nodes.map(item => ({
            drupal_id: item.drupal_id,
            title: item.title,
            link: item.link.uri_alias,
            external: item.external || item.link.uri_uuid.length < 1,
          }));
      }
      return [];
    },
    [data]
  );

  const cookiesBlock = getBlock('ba6a694a-5575-4977-b930-3269ece2a624');
  const copyrightBlock = getBlock('c0d4544a-632b-435e-9495-11d36f2fe360');
  const privacyBlock = getBlock('912192a6-27e8-4ddf-b9d2-701d7e979bc4');
  const socialLinksBlock = get(
    data.allBlockContentSocialLinksBlock,
    'nodes[0].relationships.field_social_link',
    []
  );

  return {
    data,
    cookiesBlock,
    copyrightBlock,
    privacyBlock,
    socialLinksBlock,
    getMenuLinks,
  };
}
